<template>
	<div class="table-responsive">
        <table class="table table-condensed">
			<thead >
				<tr>
					<th style="width:16%" scope="col">Providers</th>
					<th style="width:6%;text-align:center" scope="col">{{year}}</th>
					<th v-bind:class="{'active-month': currentMonth == 1}"  style="width:6%;text-align:center" scope="col">Jan</th>
					<th v-bind:class="{'active-month': currentMonth == 2}"  style="width:6%;text-align:center" scope="col">Feb</th>
					<th v-bind:class="{'active-month': currentMonth == 3}"  style="width:6%;text-align:center" scope="col">Mar</th>
					<th v-bind:class="{'active-month': currentMonth == 4}"  style="width:6%;text-align:center" scope="col">Apr</th>
					<th v-bind:class="{'active-month': currentMonth == 5}"  style="width:6%;text-align:center" scope="col">May</th>
					<th v-bind:class="{'active-month': currentMonth == 6}"  style="width:6%;text-align:center" scope="col">Jun</th>
					<th v-bind:class="{'active-month': currentMonth == 7}"  style="width:6%;text-align:center" scope="col">Jul</th>
					<th v-bind:class="{'active-month': currentMonth == 8}"  style="width:6%;text-align:center" scope="col">Aug</th>
					<th v-bind:class="{'active-month': currentMonth == 9}"  style="width:6%;text-align:center" scope="col">Sep</th>
					<th v-bind:class="{'active-month': currentMonth == 10}" style="width:6%;text-align:center" scope="col">Oct</th>
					<th v-bind:class="{'active-month': currentMonth == 11}" style="width:6%;text-align:center" scope="col">Nov</th>
					<th v-bind:class="{'active-month': currentMonth == 12}" style="width:6%;text-align:center" scope="col">Dec</th>
					<th scope="col" style="width:6%;text-align:center">Total</th>
				</tr>
			</thead>
			<tbody>
				<tr class="clickable-row" v-for="creditorFee, key, index in getCreditors">					<td class="clickable-column" style="cursor: default" scope="row"> 
						
							<router-link style="color: #212122;font-weight: normal;" :to="{name:'creditorstatement', params: { creditorId:creditorFee.creditorId, buildingId:buildingId, buildingName:buildingName, creditorName:creditorFee.creditorName}}">{{ creditorFee.creditorName }}</router-link>							
											
					</td>
					<td style="text-align: center; cursor: default"  class="clickable-column" v-bind:class="{'active-month-column': currentMonth == key2}" v-for="fee, key2 in creditorFee.fees">
						<div v-if="key2 < 13">
							<div v-if="key2 > currentMonth">
                                 
							</div>
							<div v-else>
								<div v-if="key2 < currentMonth && key2 > 0">
									<div v-if="fee == 0">
										
									</div>
									<div v-else>
										{{ $filters.toCurrency(fee) }}
									</div>
								</div>
								<div v-else>
                                    <div v-if="fee == 0">
										
									</div>
									<div v-else>
										{{ $filters.toCurrency(fee) }}
									</div>
								</div>
							</div>
						</div>
						<div v-else>

						<strong>  
							<div v-if="fee == 0">
								
							</div>
							<div v-else>
								{{ $filters.toCurrency(fee) }}
							</div> </strong>
						</div>
					</td>
                </tr>
				<tr>
					<td scope="row">
						<strong>Total</strong>
					</td>

					<td v-bind:class="{'active-month-column': currentMonth == key3}" style="text-align: center; cursor: default"  v-for="total,key3 in totalFees">
						<div v-if="key3 == currentMonth || key3 == 0">
							<strong>	
								<div v-if="total == 0">
									
								</div>
								<div v-else>
									{{ $filters.toCurrency(total) }}
								</div> 
							</strong>
						</div>
						<div v-else>
							<div> 
								<strong> 
									<div v-if="total == 0">
										
									</div>
									<div v-else>
										{{ $filters.toCurrency(total) }}
									</div> 
								</strong> 
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<modal name="creditors-form" @before-open="beforeOpen" height="auto" :minHeight="600" width="800" :minWidth="800">
			<div class="" id="expenseModal" role="dialog">
				<!-- Modal content-->
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" @click="$emit('close')" data-dismiss="modal">&times;</button>
						<h4 class="modal-title">Expense Payment</h4>
					</div>
					<div class="modal-body-expense">
						<div class="row" style="padding:5px">
							<expensepayment-form :building-id="buildingId" :creditor-id="creditorId" :month-prop="monthParam"></expensepayment-form>
						</div>
					</div>
				</div>				
			</div>
		</modal>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    title: String,
    buildingId: Number,
    buildingName: String,
    period: Number,
    filter: String,
    dark: Boolean,
  },
  //	props : ['buildingId','title'],
  data: function () {
    return {
      creditorFees: [],
      totalFees: [],
      index: 0,
      isModalVisible: true,
      creditorId: 0,
      monthParam: 0,
      currentMonth: 0,
		year: 0,

    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  mounted() {
    //this.title="";
    if (!this.$period.isCurrent(this.period)) {
      this.currentMonth = 12;
      this.year = new Date().getFullYear() - Number(this.period);
    } else {
      this.year = new Date().getFullYear() - 1;
      this.currentMonth = new Date().getMonth() + 1;
    }

    //  console.log(this.currentMonth);
    if (this.buildingId) this.fetchStatement();
    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    beforeOpen(event) {
      this.creditorId = event.params.creditortypeid;
      this.monthParam = event.params.month + 1;
    },
    showModal() {
      this.isModalVisible = true;
      alert(this.isModalVisible);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {
      this.mute = true;
      /*var request = '/admin/statment/creditors/get/';
							if ( this.title == "home" )
								request = '/home/statment/creditors/get/';
							
							request = request+this.buildingId;
							request = request + '/' + (this.period == null ? 1 : this.period);*/

      var request = "/statement/creditors";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId + "&period=" + this.period;
      /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/

      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.creditorFees = data.creditorFees;
          this.totalFees = data.totalFees;
        });
    },
    showModalTemp: function (creditorId, month) {
      this.$modal.show("creditors-form", {
        creditortypeid: creditorId,
        month: month,
      });
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      this.$modal.show("creditors-form");
    },
    hide() {
      this.$modal.hide("creditors-form");
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    getCreditors() {
      var creditorFees = this.creditorFees.filter((creditorFee) => {
        if (this.filter)
          return creditorFee.creditorName
            .toLowerCase()
            .includes(this.filter.toLowerCase());
        else return this.creditorFees;
      });

      return creditorFees;
    },
    total: function () {
      return this.creditorFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
  },
}; // Our Javascript logic
</script>
